import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { mainColors } from '../colors';

interface PropsType {
    className?: string,
    onClick?: () => void
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' }) <PropsType>`
    height: auto;
`;

export const InfoIcon = observer(({ className, onClick }: PropsType): React.ReactElement => (
    <SvgWrapper width={16} height={16} className={className} onClick={onClick} fill={mainColors.main.secondary} viewBox='0 0 16 16' >
        <g fill='none' fillRule='evenodd'>
            <g>
                <g>
                    <g>
                        <path d='M0 0H16V16H0z' transform='translate(-1139 -72) translate(1139 70) translate(0 2)' />
                        <path fill='#141922' fillRule='nonzero' d='M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 5c.513 0 .936.386.993.883L9 8v2.8c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L7 10.8V8c0-.552.448-1 1-1zm0-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z' transform='translate(-1139 -72) translate(1139 70) translate(0 2)' />
                    </g>
                </g>
            </g>
        </g>
    </SvgWrapper>
));
